import React from 'react'

function SubjectLineStep({ formData, setFormData }) {
    return (
        <div className="animate-fade-in">
            <h3 className="fw-bold text-gray-900 mb-2">Subject Line</h3>
            <p className="text-muted mb-8">Create an engaging subject line for your email.</p>
            
            <div className="mb-6">
                <label className="form-label fw-semibold">Subject Line</label>
                <input 
                    type="text" 
                    className="form-control form-control-lg" 
                    placeholder="Enter subject line"
                    value={formData.subjectLine}
                    onChange={(e) => setFormData({...formData, subjectLine: e.target.value})}
                />
            </div>
            
            <div className="alert alert-light-info d-flex align-items-center p-4">
                <span className="svg-icon svg-icon-2hx svg-icon-info me-4">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <rect opacity="0.5" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"></rect>
                        <rect x="11" y="14" width="7" height="2" rx="1" transform="rotate(-90 11 14)" fill="currentColor"></rect>
                        <rect x="11" y="17" width="2" height="2" rx="1" transform="rotate(-90 11 17)" fill="currentColor"></rect>
                    </svg>
                </span>
                <div className="d-flex flex-column">
                    <span className="fw-bold text-info">Tip</span>
                    <span className="text-muted">Keep your subject line under 50 characters for better open rates.</span>
                </div>
            </div>
        </div>
    )
}

export default SubjectLineStep
